import {InputText} from '@/components/commons/input-text/InputText'
import styled, {css} from 'styled-components'
import {Button} from '@/components/ui/button/Button'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const StyledFormGridSection = styled.div`
    display: grid;
    /* minmax(0, 1fr): a bare 1fr track has min-width: auto, so a long nowrap value
       (e.g. a selected diagnosis) would widen the column past the page instead of truncating. */
    grid-template-columns: 380px minmax(0, 1fr);
`

export const StyledFormGridSectionItem = styled.div(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 6}px;
    `
)

export const StyledFormGridSectionTitle = styled.h3(
    ({theme: {palette, typography}}) => css`
        ${typography.textLg};
        font-weight: 500;

        & > span.optional {
            font-weight: 400;
            color: ${palette.neutral[500]};
        }
    `
)

export const StyledFormGridTitle = styled.h4(
    ({theme: {typography, palette}}) => css`
        ${typography.textMd};
        color: ${palette.neutral[950]};
        font-weight: 500;
    `
)

export const StyledFormGridSectionSubTitle = styled.p(
    ({theme: {typography, palette}}) => css`
        ${typography.textMd};
        color: ${palette.neutral[600]};
        font-weight: 400;
    `
)

export const StyledInputTaxCode = styled(InputText)`
    & input {
        text-transform: uppercase;
        letter-spacing: 1px;

        &::placeholder {
            text-transform: none;
            letter-spacing: normal;
        }
    }
`

export const StyledGenerateTaxCodeButton = styled(Button)(
    ({theme: {palette, spacing}}) => css`
        color: ${palette.primary[500]};
        margin-right: ${spacing}px;
    `
)

export const StyledFormCardSection = styled(Grid)<{$padding?: number}>(
    ({theme: {palette, spacing}, $padding}) => css`
        width: 100%;
        border-radius: 6px;
        background-color: ${palette.neutral[50]};
        outline: 1px solid ${palette.neutral[200]};
        padding: ${$padding ? `${$padding * spacing}px` : 0};
    `
)

export const StyledFormAddressHint = styled(Flexbox)(
    ({theme: {palette, typography}}) => css`
        ${typography.textXs};
        color: ${palette.neutral[950]};
    `
)

export const StyledFormFieldBox = styled(GridItem)<{
    $hasError?: boolean
    $isSelected?: boolean
    $isDisabled?: boolean
    $fitContent?: boolean
}>(
    ({theme, $isSelected, $hasError, $isDisabled, $fitContent}) => css`
        height: fit-content;
        display: flex;
        align-items: center;
        background: ${$isDisabled ? theme.palette.neutral['100'] : theme.palette.neutral.white};
        white-space: nowrap;
        outline: 1px solid
            ${$hasError
                ? theme.palette.danger['300']
                : $isSelected && !$isDisabled
                  ? theme.palette.primary['600']
                  : theme.palette.neutral['300']};
        border-radius: 8px;
        width: ${$fitContent ? 'fit-content' : '100%'};
        ${!$isSelected &&
        css`
            box-shadow: ${theme.shadows.sm};
        `}

        & div,
        & label {
            width: ${$fitContent ? 'fit-content' : '100%'};
            cursor: ${$isDisabled ? 'not-allowed' : 'pointer'};
        }

        & label {
            padding: ${theme.spacing * 2}px;
        }

        & label:has(input) {
            padding-right: 0;
        }
    `
)

export const StyledLimitExpandContainer = styled(Flexbox)`
    flex-grow: 1;
`
